// extracted by mini-css-extract-plugin
export default {"description":"Description_description__0v+VX","text":"Description_text__FXrRd","heading":"Description_heading__MSEYl","li":"Description_li__j1KKJ"};